module.exports = __webpack_public_path__ + "static/media/hab1-2.a518f90f.jpg";